export function resolveMaasModelStoragePaths(_prefix: string): Record<string, string> {
  return {};
}
